<template>
    <router-link class="btn inline-s"
                 :disabled="disabled"
                 :to="prevRoute">
        Cancel
    </router-link>
</template>
<script>
    export default {
        name: 'v-cancel',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            defaultRoute: {
                type: Object,
                default: {name: 'dashboard'},
            },
        },
        watch: {},
        computed: {
            prevRoute() {
                const prevRoute = this.$store.state.route.from;

                if (prevRoute && prevRoute.name) {
                    return {...prevRoute};
                }
                const {isAllowed} = this.$auth.pages[this.defaultRoute.name];
                return isAllowed ? {...this.defaultRoute} : {name: 'dashboard'};
            },
        },
    };
</script>
